import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungJena() {
  return (
    <CityPageTemplate
      city="Jena"
      slug="jena"
      intro="Jena als Stadt der Wissenschaft und Innovation – Deine Finanzplanung sollte genauso zukunftsorientiert sein."
      description="Unabhängige & digitale Finanzberatung für Jena: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
